import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import KilometrajeChart from './KilometrajeChart';
import FalconCardHeader from '../../../../../../components/common/FalconCardHeader';
import { Badge, Card, Col, Row, Form } from 'react-bootstrap';

const Kilometraje = ({ data }) => {
    const [userCount, setUserCount] = useState(0);
    const [kilometrajeData, setKilometrajeData] = useState([]);
    useEffect(() => {
        if (data.length > 0) {
            // **Agrupar por fecha y sumar kilómetros recorridos**
            const kmPorDia = data.reduce((acc, recorrido) => {
                if (!recorrido.fecha || typeof recorrido.distancia !== 'number') return acc; // Evita datos inválidos

                const fecha = recorrido.fecha.split(' ')[0]; // **Extrae solo la fecha (YYYY/MM/DD)**
                const distancia = parseFloat(recorrido.distancia || 0); // Formatear a km

                if (!acc[fecha]) {
                    acc[fecha] = 0;
                }
                acc[fecha] += distancia;
                return acc;
            }, {});

            // **Convertir en array de objetos para la gráfica**
            const kmArray = Object.keys(kmPorDia).map(fecha => ({
                fecha,
                kilometros: parseFloat(kmPorDia[fecha].toFixed(2)) // Formatear a km sin concatenar
            }));

            setKilometrajeData(kmArray);
            setUserCount(kmArray.length > 0 ? kmArray.reduce((total, d) => total + d.kilometros, 0).toFixed(2) : 0);
        }
    }, [data]);

    return (
        <Card className="h-100 ">
            <FalconCardHeader
                title="Kilómetros recorridos totales"
                light
                titleTag="h6"
                endEl={
                    <>
                        <h5 >{parseFloat(userCount).toFixed(2)} km</h5>
                    </>
                }
            />


            <Card.Body className="p-2">


                {/*     <Row className="justify-content-center text-center" >
                    <Col md={12}>
                        <h5 >{parseFloat(userCount).toFixed(2)} km</h5>
                    </Col>
                    <Col md={12}>
                        <Form.Label>Km recorrido diario</Form.Label>

                    </Col>
                </Row> */}

                <div className='mt-5'></div>

                <KilometrajeChart setUserCount={setUserCount} data={kilometrajeData} />
            </Card.Body>
        </Card >
    );
};

Kilometraje.propTypes = {
    data: PropTypes.array.isRequired
};

export default Kilometraje;
